export class ExceptionDetails {
    location:string;
    user:string;
    method?:string;
    documentsId?: string[];
    trace?: string[];
};